import React from "react";
import { PawPrint } from "lucide-react";

export function Logo({ light = false }) {
  return (
    <span className="flex items-center gap-2 font-heading font-extrabold text-xl">
      <span className="h-9 w-9 rounded-xl bg-[#F59E0B] grid place-items-center rotate-[-6deg] shadow-[0_3px_0_#B45309]">
        <PawPrint className="h-5 w-5 text-[#1E293B]" />
      </span>
      <span className={light ? "text-white" : "text-[#1E293B]"}>PackLog</span>
    </span>
  );
}
